<template>
  <!-- 系列课程 -->
  <div>
    <van-pull-refresh style="min-height: 100vh" v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
      <van-list ref="winPrize" v-if="winPrizeList.length > 0" v-model:loading="loading" :immediate-check="false"
        :finished="finished" finished-text="已到底~" @load="onLoad" :offset="500" class="item-list">
        <van-cell @click="goSeriesDetail(item.webSerId)" v-for="(item, index) in winPrizeList" :key="index"
          class="list-item">
          <el-image :src="item.url" fit="cover" class="winPrizeimg">
            <img class="" style="object-fit: cover" :src="require('@/assets/stormPassAnswer/ranking.png')"
              slot="error" />
          </el-image>
          <div class="list-title">
            <div>
              <p class="name">{{ item.webSerTitle }}</p>
            </div>
            <div>
              <span class="time">内含 {{ item.webLesCount }} 门课程</span>
            </div>
          </div>
        </van-cell>
      </van-list>
      <div v-else class="item-none">
        <img class="default" :src="require('@/assets/studyCentre/none.png')" alt="" />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { filePerviewPath } from "@/api/globalApi.js";
import {
  getPublished,
} from "@/api/studyCentre";
export default {
  data() {
    return {
      winPrizeList: [],
      formData: {
        pageNum: 1,
      },
      winnerNum: 0,
      mywinnerNum: 0,
      isLoading: false, //下拉刷新
      loading: false,
      finished: false,
    }
  },
  created() {
    this.getPublishedLsit()
  },
  mounted() {
    document.title = "系列课程";

  },
  computed: {
    ...mapState(["needLoginType"])
  },
  methods: {
    ...mapMutations(["setNeedLoginType"]),
    //下拉刷新
    onRefresh() {
      this.isLoading = true;
      this.formData.pageNum = 1;
      this.winPrizeList = []
      this.getPublishedLsit()
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    onLoad() {
      console.log("dy");
      ++this.formData.pageNum;
      this.getPublishedLsit();
    },
    //系列课程列表
    goSeriesDetail(id) {
      window.location.href = '/seriesDetail?id=' + id;
    },
    //列表
    getPublishedLsit() {
      // 异步操作，提交 mutation 更新状态
      this.setNeedLoginType(true);
      console.log("this.$store.state", this.$store.state);

      getPublished(this.formData).then(({ data }) => {
        if (data.code == 200) {
          if (data.data.list.length > 0) {
            this.loading = false;
            this.winPrizeList = [...this.winPrizeList, ...data.data.list];
            this.winPrizeList.forEach((ele) => {
              let obj = {
                fileObjId: ele.webSerCover,
                downType: "cover",
              };
              ele.url = filePerviewPath(obj);
            });
          } else {
            this.finished = true;
          }

        }
      });
    }

  },
} 
</script>
<style scoped>
.winPrizeimg {
  border-radius: 4px;
  width: 100%;
  height: 190px;
  position: relative;
}

.list-item {
  padding: 6px 16px;
}

.list-title {
  position: absolute;
  bottom: 16px;
  left: 16px;
  width: 95%;
}

.name {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  white-space: nowrap;
  /* 防止文字换行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
}

.time {
  font-size: 12px;
  color: #FFFFFF;
}

.van-cell::after {
  border-bottom: #FFFFFF;
}

.item-none {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.default {
  width: 160px;
  height: 185px;
}

.item-more {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 14px;
  color: #bdbaba;
}
</style>